<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-blue-400 hover:text-indigo-600" :href="route('ads')"> <icon name="store-front" class="w-6 h-6 -mt-1 mr-2 fill-blue-400 inline-block" />Experiencia</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.titulo }}
    </h1>
    <!-- <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('category')">Cancelar Cambios</inertia-link> -->

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <div class="w-full lg:w-1/2 p-4 rounded bg-blue-100">
          <img v-if="!form.fullurl" :src="'https://lapedrera.com.uy/img/anuncios/' + form.foto" class="w-full" alt="" />
          <img :src="form.fullurl" v-if="form.fullurl" class="w-full" alt="" />
        </div>

        <form @submit.prevent="uploadImage" class="w-full lg:w-1/2">
          <div class="ml-4 items-center justify-center bg-grey-lighter">
            <label
              class="w-64 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-gray-400 cursor-pointer hover:bg-blue-400 hover:text-white"
            >
              <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
              </svg>
              <span class="mt-2 text-base leading-normal">Modificar imagen</span>

              <input type="file" class="hidden" accept="image/png, image/gif, image/jpeg" @input="pictureForm.picture = $event.target.files" />
            </label>
          </div>
          <div class="image-up py-6 px-4 bg-blue-100 mt-3" v-if="pictureForm.picture">
            <div class="flex flex-wrap gap-4">
              <div class="item" v-for="preloader in pictureForm.picture" :key="preloader.name">
                <img :src="createObjectURL(preloader)" style="max-width: 150px" :title="preloader.name" />
              </div>
            </div>

            <progress v-if="pictureForm.progress" :value="pictureForm.progress.percentage" max="100">{{ pictureForm.progress.percentage }}%</progress>

            <loading-button
              :loading="pictureForm.processing"
              class="inline-block font-bold py-3 mt-2 px-3 py-2 text-center text-white transition bg-blue-500 rounded-sm shadow hover:shadow-lg hover:bg-green-600 focus:outline-none waves-effect"
              type="submit"
              >Actualizar imagen</loading-button
            >

            <!-- Sustituir imagen
          </button> -->
            <a type="cancel" href="javascript:;" v-on:click="pictureForm.reset()" class="inline-block py-3 mt-2 text-center text-red-700 transition">Cancelar</a>
          </div>
        </form>
      </div>
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.titulo" :error="form.errors.titulo" class="pr-6 pb-8 w-full lg:w-1/2" label="Titulo" />
          <text-input v-model="form.link" :error="form.errors.link" class="pr-6 pb-8 w-full lg:w-1/2" label="Link" />
          <text-input v-model="form.mapongo" :error="form.errors.mapongo" class="pr-6 pb-8 w-full lg:w-1/2" label="Coordenadas en el Mapa" />
          <a href='http://www.google.com/maps?ll=-34.591327,-54.127965&spn=0.007092,0.016512&t=m&z=17' class="pt-12 pl-0 w-full lg:w-1/2 map" target='_blank'>Codigo del mapa</a><br>
          <text-input v-model="form.whatsapp" :error="form.errors.whatsapp" class="pr-6 pb-8 w-full lg:w-1/2" label="Whatsapp" />
          <select-input v-model="form.localidad" :error="form.errors.localidad" class="pr-6 pb-8 w-full lg:w-1/2" label="Localidad">
            <option :value="null" />
            <option value="La Pedrera">La Pedrera</option>
            <option value="Punta Rubia">Punta Rubia</option>
            <option value="San Sebastián">San Sebastián</option>
            <option value="Arachania">Arachania</option>
            <option value="anta Isabel">Santa Isabel</option>
            <option value="Tajamares de La Pedrera">Tajamares de La Pedrera</option>
            <option value="La Serena Golf">La Serena Golf</option>
            <option value="San Antonio">San Antonio</option>
            <option value="Pueblo Nuevo">Pueblo Nuevo</option>
            <option value="Atlántica">Atlántica</option>
            <option value="Oceanía del Polonio">Oceanía del Polonio</option>
            <option value="La Paloma">La Paloma</option>
            <option value="Zona rural">Zona rural</option>
          </select-input>
          <div class="pr-6 pb-8 w-full">
            <label  class="form-label inline-block -mt-1">Descripcion corta:</label> 
            <vue-editor class="w-full pr-6 pb-4 mb-0" v-model="form.descripcion" :error="form.errors.descripcion" :editor-toolbar="customToolbar" />
           </div>
           <div class="pr-6 pb-8 w-full">
              <label  class="form-label inline-block -mt-1">Descripcion larga:</label> 
              <vue-editor class="w-full pr-6 pb-4 mb-0" v-model="form.descripcion_larga" :error="form.errors.descripcion_larga" :editor-toolbar="customToolbar" />
           </div>
          <div class="pr-6 pb-8 w-full lg:w-1/3">
            <label for="act" class="form-label inline-block -mt-1">Activado:</label> 
              <input v-model="form.publicado" :error="form.errors.publicado"  id="act" class="mr-1" type="checkbox" />
           </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="food" class="form-label inline-block -mt-1">Experiencia Gastronomica:</label> 
              <input v-model="form.gastronomia" :error="form.errors.gastronomia"  id="food" class="mr-1" type="checkbox" />
           </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Experiencia</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar Experiencia</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from "@/Shared/Icon";
import Layout from "@/Shared/Layout";
import TextInput from "@/Shared/TextInput";
import TextAreaInput from "@/Shared/TextAreaInput";
import SelectInput from "@/Shared/SelectInput";
import LoadingButton from "@/Shared/LoadingButton";
import TrashedMessage from "@/Shared/TrashedMessage";
import { VueEditor } from "vue2-editor";

export default {
  metaInfo() {
    return { title: this.form.titulo };
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextAreaInput,
    VueEditor
  },
  layout: Layout,
  props: {
    ad: Object
  },
  remember: "form",
  data() {
    return {
      customToolbar: [
        [{ header: [false, 2] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons

        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

        ["link"],
        ["clean"] // remove formatting button,
      ],
      form: this.$inertia.form({
        id: this.ad.id,
        link: this.ad.link,
        titulo: this.ad.titulo,
        descripcion: this.ad.descripcion,
        foto: this.ad.foto,
        publicado: this.ad.publicado,
        fullurl: this.ad.fullurl,
        localidad: this.ad.localidad,
        mapongo: this.ad.mapongo,
        whatsapp: this.ad.whatsapp,
        descripcion_larga: this.ad.descripcion_larga,
        gastronomia: this.ad.gastronomia
      }),
      pictureForm: this.$inertia.form({
        picture: null
      })
    }; 
  },
  methods: {
    createObjectURL(preloader) {
      return URL.createObjectURL(preloader);
    },
    uploadImage() {
      let propId = this.form.id;
      console.log(propId);
      // console.log(this.pictureForm);
      this.pictureForm
        .transform(data => ({
          ...data,
          id: propId
        }))
        .post("/upload-experience", {
          onSuccess: page => {
            let _this = this;
            this.pictureForm.reset();
            _this.form.fullurl = page.props.ad.fullurl;
          }
        });
    },
    update() {
      this.form.put(this.route("ads.update", this.ad.id));
    },
    destroy() {
      if (confirm("Esta seguro que desea borrar esta experiencia?")) {
        this.$inertia.delete(this.route("ads.destroy", this.ad.id));
      }
    }
  }
};
</script>
